import styles from './IconDefault.module.scss';

export function IconRocket() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				d="M6 27L11.4545 15L12 27H6Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M34 27L28.5455 15L28 27H34Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M11.791 11C13.5199 5.3713 17.6671 2.69598 20 2C22.333 2.69598 26.4801 5.3713 28.209 11H11.791Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 39C19.4477 39 19 38.5523 19 38L19 35C19 34.4477 19.4477 34 20 34C20.5523 34 21 34.4477 21 35L21 38C21 38.5523 20.5523 39 20 39ZM17 37C16.4477 37 16 36.5523 16 36L16 34C16 33.4477 16.4477 33 17 33C17.5523 33 18 33.4477 18 34L18 36C18 36.5523 17.5523 37 17 37ZM22 35C22 35.5523 22.4477 36 23 36C23.5523 36 24 35.5523 24 35L24 33C24 32.4477 23.5523 32 23 32C22.4477 32 22 32.4477 22 33L22 35Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M28.209 11C28.7034 12.6094 29 14.4603 29 16.5753C29 26.0877 27 29.4886 26 30H23.5M25 5.32812C23.2684 3.44704 21.3365 2.39871 20 2C17 2.89498 11 7.06301 11 16.5753C11 21.5932 11.5565 24.9104 12.2292 27C12.8318 28.8716 13.5275 29.7584 14 30H18.5"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.8 30L16 33H24L23.2 30"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.5 27H6L8.5 21.5"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M29 16L34 27H28.5"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="20"
				cy="16"
				r="3"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M17 16C17 17.6569 18.3431 19 20 19C21.6569 19 23 17.6569 23 16C23 14.3431 21.6569 13 20 13"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 23V25"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="27"
				cy="8"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
		</svg>
	);
}
